// Layout.js
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import mainLogo from './images/kofer.png'
import telefon from './images/telephone.png'

const Layout = ({ children }) => {

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='mainContainer'>
      <header className='headerMainLogo'>
        <div className='mainTitle'>Putujuće pozorište Kofer Teatar</div>
        {/* <img src={mainLogo} alt='logo' className='mainLogo' /> */}
        
      <div className="navBarContainer">
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
      </div>

      <nav className={isOpen ? "navOpen" : ""}>
        <ul>
          <li><Link to="/" onClick={() => setIsOpen(false)}>Početna</Link></li>
          <li><Link to="/repertoar" onClick={() => setIsOpen(false)}>Repertoar</Link></li>
          <li><Link to="/o-nama" onClick={() => setIsOpen(false)}>O nama</Link></li>
          <li><Link to="/galerija" onClick={() => setIsOpen(false)}>Galerija</Link></li>
        </ul>
      </nav>
    </div>

        {/* Ovde ide sadržaj stranice */}
        <main>
          {children}
        </main>

        <footer className="footer">
          <div className="footer-content">
            <div className="social-links">
              <a href="https://www.instagram.com/koferteatar/?igsh=MXVrcXJjejhvcXB6cQ%3D%3D#" target="_blank" rel="noreferrer" aria-label="Instagram">
                <img src="https://img.icons8.com/color/48/instagram-new--v1.png" alt="Instagram" />
              </a>
              <a href="https://www.facebook.com/pozoriste.koferteatar/" target="_blank" rel="noreferrer" aria-label="Facebook">
                <img src="https://img.icons8.com/color/48/facebook-new.png" alt="Facebook" />
              </a>
              <a href="https://www.youtube.com/channel/UCe-Gd1lNSMlD1Dj1SCtgBNA/featured" target="_blank" rel="noreferrer" aria-label="YouTube">
                <img src="https://img.icons8.com/color/48/youtube-play.png" alt="YouTube" />
              </a>
            </div>

            <div className="contact-info">
              <p>
                <a href="mailto:koferteatar@yahoo.com">
                  <img src="https://img.icons8.com/color/48/secured-letter.png" alt="Email" className="icon" />
                  koferteatar@yahoo.com
                </a>
              </p>
              <p>
                <img src={telefon} className='telefon' alt="Telefon" />
                065 216224
              </p>
            </div>

            <p className="copyright">
                Kofer Teatar
            </p>
          </div>
        </footer>
      </header>
    </div>
  );
};

export default Layout;
